export default {
  "advent": {
    "season": "Adventné obdobie",
    "feria": "{{day}} po {{week}}. adventnej nedeli",
    "sunday": "{{week}} adventná nedeľa"
  },
  "christmastide": {
    "season": "Vianočné obdobie",
    "day": "{{day}} vo Vianočnom období",
    "octave": "{{count}} deň v oktáve narodenia Pána",
    "sunday": "{{count}} nedeľa po narodení Pána"
  },
  "epiphany": {
    "season": "Zjavenie Pána",
    "before": "{{day}} vo vianočnom období",
    "after": "{{day}} po Zjavení Pána"
  },
  "ordinaryTime": {
    "season": "Cezročné obdobie",
    "feria": "{{day}} {{week}} týždňa v Cezročnom období",
    "sunday": "{{week}} nedeľa v Cezročnom období"
  },
  "lent": {
    "season": "Pôstne obdobie",
    "feria": "{{day}} po {{week}}. pôstnej nedeli",
    "sunday": "{{week}} pôstna nedeľa",
    "day_after_ash_wed": "{{day}} po Popolcovej strede"
  },
  "holyWeek": {
    "season": "Veľký týždeň",
    "feria": "{{day}} Veľkého týždňa"
  },
  "eastertide": {
    "season": "Veľkonočné obdobie",
    "feria": "{{day}} po {{week}} veľkonočnej nedeli",
    "sunday": "{{week}} veľkonočná nedeľa",
    "octave": "Veľkonočný {{day}}"
  },
  "celebrations": {
    "allSaints": "Všetkých svätých",
    "annunciation": "Zvestovanie Pána",
    "ascension": "Nanebovstúpenie Pána",
    "ashWednesday": "Popolcová streda",
    "assumption": "Nanebovzatie Panny Márie",
    "baptismOfTheLord": "Krst Krista Pána",
    "birthOfJohnTheBaptist": "Narodenie svätého Jána Krstiteľa",
    "christmas": "Narodenie Pána",
    "christTheKing": "Krista Kráľa",
    "corpusChristi": "Najsvätejšieho Kristovho Tela a Krvi",
    "divineMercySunday": "Nedeľa Božieho milosrdenstva",
    "easter": "Nedeľa Pánovho zmŕtvychvstania",
    "epiphany": "Zjavenie Pána",
    "goodFriday": "Veľký piatok",
    "guardianAngelOfPortugal": "Anjela strážcu Portugalska",
    "holyFamily": "Svätej rodiny Ježiša, Márie a Jozefa",
    "holySaturday": "Biela sobota",
    "holyThursday": "Zelený štvrtok",
    "immaculateConception": "Nepoškvrnené počatie Panny Márie",
    "immaculateHeartOfMary": "Nepoškvrneného Srdca Panny Márie",
    "josephHusbandOfMary": "Svätého Jozefa, ženícha Panny Márie",
    "maryMotherOfGod": "Panny Márie Bohorodičky",
    "palmSunday": "Kvetná nedeľa",
    "pentecostSunday": "Zoslanie Ducha Svätého",
    "peterAndPaulApostles": "Svätých Petra a Pavla, apoštolov",
    "presentationOfTheLord": "Obetovanie Pána",
    "sacredHeartOfJesus": "Najsvätejšieho Srdca Ježišovho",
    "theExaltationOfTheHolyCross": "Povýšenie Svätého kríža",
    "transfiguration": "Premenenie Pána",
    "trinitySunday": "Najsvätejšej Trojice"
  },
  "sanctoral": {
    "205BlessedMartyrsOfJapan": "205 blahoslavených mučeníkov Japonska",
    "allSaintsOfIreland": "Všetkých svätých Írska",
    "allSaintsOfWales": "Všetkých svätých Walesu",
    "allSouls": "Všetkých verných zosnulých",
    "birthOfTheBlessedVirginMary": "Narodenie Panny Márie",
    "blessedAlbertinaBerkenbrockVirginAndMartyr": "Blahoslavenej Albertiny Berkenbrockovej, panny a mučenice",
    "blessedAloysiusStepinacBishopAndMartyr": "Blahoslaveného Alojza Stepinaca, biskupa a mučeníka",
    "blessedAndreGrassetPriestAndMartyr": "Blahoslaveného Andreja Grasseta, kňaza a mučeníka",
    "blessedAnielaSalawaVirgin": "Blahoslavenej Angely Salawej, panny",
    "blessedAntoniNowowiejskiBishopAndCompanionsMartyrs": "Blahoslaveného Antona Nowowiejskeho, biskupa, a spoločníkov, mučeníkovi",
    "blessedAugustinKazoticBishopAndMartyr": "Blahoslaveného Augustína Kažotića, biskupa a mučeníka",
    "blessedBartholomewOfTheMartyrsBishop": "Blahoslaveného Bartolomeja od mučeníkov, biskup",
    "blessedBartolomeLaurelReligiousAndMartyr": "Blahoslaveného Bartolomeja Laurela, rehoľníka a mučeníka",
    "blessedBogumilBishop": "Blahoslaveného Bohumila, biskupa",
    "blessedBoleslawaMariaLamentVirginAndSaintAngelaMericiVirgin": "Blahoslavenej Boleslavy Márie Lamentovej, Panny/Svätej Angely Merici, panny",
    "blessedBronislawaVirgin": "Blahoslavenej Bronislavy, panny",
    "blessedBronislawMarkiewiczPriest": "Blahoslaveného Bronislava Markiewicza, kňaza",
    "blessedCarlosManuelRodriguez": "Blahoslaveného Karla Emanuela Rodrígueza Santiaga",
    "blessedCatherineOfSaintAugustineVirgin": "Blahoslavenej Kataríny od sv. Augustína, panny",
    "blessedCeferinoNamuncura": "Blahoslaveného Zefirína Namuncurá",
    "blessedCeslausAndSaintHyacinthPriests": "Blahoslaveného Česlava a svätého Hyacinta, kňazov",
    "blessedCharlesSpinolaPriestAndMartyr": "Blahoslaveného Karola Spinolu, kňaza a mučeníka",
    "blessedColumbaMarmionPriest": "Blahoslaveného Columbu Marmiona, kňaza",
    "blessedCzeslawPriest": "Blahoslaveného Česlava, kňaza",
    "blessedDinaBelangerVirgin": "Blahoslavenej Diny Belangerovej, panny",
    "blessedDominicOfTheMotherOfGodDominicBarberiPriest": "Blahoslaveného Dominika od Matky Božej Barberi, kňaza",
    "blessedEdmundBojanowski": "Blahoslaveného Edmunda Bojanowského",
    "blessedEdmundIgnatiusRiceReligious": "Blahoslaveného Edmunda Ignáca Rica, rehoľníka",
    "blessedElisabethHesselbaldVirgin": "Blessed Elisabeth Hesselbald, Virgin",
    "blessedEmilieTavernierGamelinReligious": "Blahoslavenej Márie Emílie Tavernier Gamelinovej, rehoľnice",
    "blessedFredericJanssoonePriest": "Blahoslaveného Frederika Janssoona, kňaza",
    "blessedGeorgeMatulewiczBishop": "Blahoslaveného Juraja Matulaitisa, biskupa",
    "blessedGisela": "Blahoslavenej Gizely Uhorskej, rehoľnice",
    "blessedGoncaloDeAmarantePriest": "Blahoslaveného Gonçala de Amarante, kňaza",
    "blessedGoncaloDeLagosPriest": "Blahoslaveného Gonçala de Lagos, kňaza",
    "blessedGraziaOfCattaro": "Blahoslavenej Grácie Kotorskej",
    "blessedHemmingBishop": "Blahoslaveného Hemminga, biskupa",
    "blessedHenrySusoPriest": "Blahoslaveného Henricha Susa, kňaza",
    "blessedHonoratKozminskiPriest": "Blahoslaveného Honoráta Kożmińského, kňaza",
    "blessedHroznataMartyr": "Blahoslaveného Hroznatu, mučeníka",
    "blessedInacioDeAzevedoPriestAndCompanionsMartyrs": "Blahoslaveného Ignáca de Azevedo, kňaza, a spoločníkov, mučeníkov",
    "blessedInnocentXiPope": "Blahoslaveného Inocenta XI., pápeža",
    "blessedIrishMartyrs": "Blahoslavených írskych mučeníkov",
    "blessedIstvanSandorMartyr": "Blahoslaveného Štefana Šándora, mučeníka",
    "blessedIvanMerz": "Blahoslaveného Ivana Merza",
    "blessedJacintaAndFranciscoMarto": "Svätých Hyacinty a Františka Martovcov",
    "blessedJakubStrzemieBishop": "Blahoslaveného Jakuba Strzemię, biskupa",
    "blessedJerzyMatulewiczBishop": "Blahoslaveného Juraja Matulaitisa, biskupa",
    "blessedJoanOfPortugalVirgin": "Blahoslavenej Jany Portugalskej, panny",
    "blessedJohnBeyzymPriest": "Blahoslaveného Jána Beyzyma, kňaza",
    "blessedJohnHenryNewmanPriest": "Blahoslaveného Johna Henryho Newmana, kňaza",
    "blessedJolantaReligious": "Blahoslavenej Jolany, rehoľnice",
    "blessedJosephVazPriest": "Blahoslaveného Jozefa Vaza, kňaza",
    "blessedJuniperoSerraPriest": "Blahoslaveného Junipera Serru, kňaza",
    "blessedKarlOfAustria": "Blahoslaveného Karola Habsburského",
    "blessedKarolinaKozkownaVirginAndMartyr": "Blahoslavenej Karolíny Kozkownej, panny a mučenice",
    "blessedKuriakoseEliasChavaraPriest": "Blahoslaveného Kyriaka Eliáša Čavaru, kňaza",
    "blessedLauraVicunaVirgin": "Blahoslavenej Laury Vicuñe, panny",
    "blessedLouisZephirinMoreauBishop": "Blahoslaveného Ľudovíta Zefirína Moreau, biskupa",
    "blessedMarcelinaDarowskaReligious": "Blahoslavenej Marcelíny Darowskej, rehoľnice",
    "blessedMariaAdeodataPisaniVirgin": "Blahoslavenej Márie Adeodaty Pisaniovej, panny",
    "blessedMariaDoloresRodriguezSopenaVirgin": "Blahoslavenej Márie Dolores Rodríguez Sopeñe, panny",
    "blessedMariaStellaAndCompanionsVirginsAndMartyrs": "Blahoslavenej Márie Stelly a spoločníčok, pannien a mučeníc",
    "blessedMariaTeresaLedochowskaVirgin": "Blahoslavenej Márie Terezy Ledochowskej, panny",
    "blessedMariaTheresaChiramelVirgin": "Blahoslavenej Márie Terézie Chiramelovej, panny",
    "blessedMarieAnneBlondinVirgin": "Blahoslavenej Márie Anny Blondinovej, panny",
    "blessedMarieLeonieParadisVirgin": "Blahoslavenej Márie Leónie Paradisovej, panny",
    "blessedMarieRoseDurocherVirgin": "Blahoslavenej Márie Durocherovej, panny",
    "blessedMaryAngelaTruszkowskaVirgin": "Blahoslavenej Márie Angely Truszkowskej, panny",
    "blessedMaryOfJesusCrucifiedPetkovicVirgin": "Blahoslavenej Márie od ukrižovaného Ježiša Petković, panny",
    "blessedMaryOfJesusTheGoodShepherdVirgin": "Blahoslavenej Márie od Ježiša Dobrého Pastiera, panny",
    "blessedMichaelKozalBishopAndMartyr": "Blahoslaveného Michaela Kozala, biskupa a mučeníka",
    "blessedMiguelAgustinProPriestAndMartyr": "Blahoslaveného Michaela Pro, kňaza a mučeníka",
    "blessedNazariaIgnaciaMarchReligious": "Blahoslavenej Nazárie Ignácie March Mesa (Nazárie od Svätého Terézie od Ježiša), rehoľnice",
    "blessedNazjuFalzon": "Blahoslaveného Ignáca Falzona",
    "blessedNicolasStenoBishop": "Blahoslaveného Nicolasa Stena, biskupa",
    "blessedOleksiyZarytskyiPriestAndMartyr": "Blahoslaveného Alexeja Zarytského, kňaza a mučeníka",
    "blessedOsannaOfCattaroVirgin": "Blahoslavenej Hosanny Kotorskej, panny",
    "blessedPeterKibePriestAndCompanionsMartyrs": "Blahoslaveného Petra Kibeho, kňaza, a spoločníkov, mučeníkov",
    "blessedPeterToRotMartyr": "Blahoslaveného Petra To Rota, mučeníka",
    "blessedPiusIxPope": "Blahoslaveného Pia IX., pápeža",
    "blessedRafalChylinskiPriest": "Blahoslaveného Rafaela Chylinského, kňaza",
    "blessedSalomeVirgin": "Blahoslavenej Salomey Poľskej, panny",
    "blessedSanchaAndMafaldaVirginsOrBlessedTheresaOfPOrtugalReligious": "Blahoslavených Sanche a Mafaldy, panny, alebo blahoslavenej Terezy Portugalskej, rehoľnice",
    "blessedsAndreDeSoveralAndAmbrosioFranciscoFerroPriestsAndMartyrs": "Blahoslavených Andreja de Soverala a Ambróza Františka Ferra, mučeníka",
    "blessedSaraSalkahaziVirginAndMartyr": "Blahoslavenej Sáry Salkaháziovej, panny a mučenice",
    "blessedsCarlosSpinolaAndJeronimoDeAngelisPriestsAndMartyrs": "blahoslavených Karla Spinolu a Hieronyma de Angelis, kňazov a mučeníkov",
    "blessedSebastianDeAparicioReligious": "Blahoslaveného Šebastiána de Aparicio, Religious",
    "blessedsNykytaBudkaAndVasylVelychkowskyBishopsAndMartyrs": "Blahoslavených Nikity Budku a Vasiľa Velichkovského, biskupov a mučeníkov",
    "blessedsPedroZunigaAndLuisFloresPriestsAndMartyrs": "Blahoslavených Petra de Zúñigu a Ľudovíta Floresa, kňazov a mučeníkov",
    "blessedTheodoreRomzhaBishopAndMartyr": "Blahoslaveného Teodora Romžu, biskupa a mučeníka",
    "blessedVilmosAporBishopAndMartyr": "Blahoslaveného Vilmosa Apora, biskupa a mučeníka",
    "blessedVincentKadlubekBishop": "Blahoslaveného Vincenta Kadlubka, biskupa",
    "blessedVincentLewoniukAndCompanionsMartyrsOfPratulin": "Blahoslaveného Vincenta Lewoniuka a spoločníkov, mučeníkov",
    "blessedVladimirGhikaPriestAndMartyr": "Blahoslaveného Vladimíra Ghiku, kňaza a mučeníka",
    "blessedWladyslawBladzinskiPriestAndCompanionsMartyrs": "Blahoslaveného Vladislava Błądzińskiho, kňaza, a spoločníkov, mučeníkov",
    "blessedWladyslawOfGielniowPriest": "Blahoslaveného Vladislava z Gielniowa, kňaza",
    "blessedZdenkaSchelingovaVirginAndMartyr": "Blahoslavenej Zdenky Schelingovej, panny a mučenice",
    "chairOfSaintPeterApostle": "Katedra svätého Petra, apoštola",
    "conversionOfSaintPaulApostle": "Obrátenie svätého Pavla, apoštola",
    "dedicationOfAParticularChurch": "Výročie posviacky chrámov, ktorých deň posviacky je neznámy",
    "dedicationOfTheBasilicaOfSaintMaryMajor": "Výročie posviacky Hlavnej mariánskej baziliky v Ríme",
    "dedicationOfTheBasilicasOfSaintsPeterAndPaulApostles": "Výročie posviacky bazilík svätého Petra a svätého Pavla, apoštolov",
    "dedicationOfTheLateranBasilica": "Výročie posviacky Lateránskej baziliky",
    "discoveryOfTheHiddenChristians": "Objavenia skrytých kresťanov",
    "findingOfTheHolyCross": "Nájdenie Svätého kríža",
    "firstMartyrsOfTheChurchOfRome": "Prvých svätých mučeníkov Cirkvi v Ríme",
    "guardianAngels": "Svätých anjelov strážcov",
    "holyInnocentsMartyrs": "Svätých Neviniatok, mučeníkov",
    "holyNameOfTheBlessedVirginMary": "Najsvätejšieho mena Panny Márie",
    "hungarianSaintsAndBlesseds": "Maďarských svätých a blahoslavených",
    "immaculateConceptionOfTheBlessedVirginMaryPrincipalPatronessOfThePhilippines": "Nepoškvrneného počatia Panny Márie, hlavná Patrónka Filipín",
    "maryMotherOfTheChurch": "Preblahoslavenej Panny Márie, Matky Cirkvi",
    "mostHolyNameOfJesusOrOurLadyOfBethlehem": "Najsvätejšieho mena Ježiš alebo Panny Márie Betlehemskej",
    "ourLadyHelpOfChristians": "Panny Márie, Pomocnice kresťanov",
    "ourLadyMediatrix": "Panny Márie, Prostrednice všetkých milostí",
    "ourLadyMediatrixOfAllGrace": "Panny Márie, Prostrednice všetkých milostí",
    "ourLadyMotherOfChristianUnity": "Panny Márie, Matky jednoty kresťanov",
    "ourLadyMotherOfDivineProvidencePatronessOfPuertoRico": "Panny Márie, Matky Božej Prozreteľnosti, Patrónky Portorika",
    "ourLadyMotherOfMercy": "Panny Márie Ostrobramskej",
    "ourLadyOfAparecidaPatronessOfBrazil": "Panna Mária z Aparecidy, Patrónka Brazílie",
    "ourLadyOfBistrica": "Panny Márie z Marije Bistrice",
    "ourLadyOfCzestochowa": "Panny Márie Čenstochovskej",
    "ourLadyOfFatima": "Blahoslavenej Panny Márie Fatimskej",
    "ourLadyOfGoodCounsel": "Panny Márie Dobrej Rady",
    "ourLadyOfGuadalupe": "Preblahoslavenej Panny Márie Guadalupskej",
    "ourLadyOfHungary": "Patrónka Maďarov",
    "ourLadyOfItati": "Panny Márie Itatskej",
    "ourLadyOfKnock": "Panny Márie z Knock",
    "ourLadyOfLanka": "Panny Márie z Lanky",
    "ourLadyOfLebanon": "Panny Márie z Lebanonu",
    "ourLadyOfLoreto": "Preblahoslavenej Panny Márie Loretánskej",
    "ourLadyOfLourdes": "Preblahoslavenej Panny Márie Lurdskej",
    "ourLadyOfLujanPatronessOfArgentina": "Panny Marie Lujánska",
    "ourLadyOfMadhu": "Panny Márie z Madhu",
    "ourLadyOfMercy": "Panny Márie milosrdenstva",
    "ourLadyOfMountCarmel": "Preblahoslavenej Panny Márie Karmelskej",
    "ourLadyOfMountCarmelMotherAndQueenOfChile": "Panny Márie Karmelskej, Matky a Kráľovnej Chile",
    "ourLadyOfPeace": "Panny Márie pokoja",
    "ourLadyOfPerpetualHelpOrBlessedLeonidFeodorovPriestAndMartyr": "Panny Márie ustavičnej pomoci alebo blahoslaveného Leonida Fjodorova, kňaza a mučeníka",
    "ourLadyOfSorrows": "Sedembolestnej Panny Márie, patrónky Slovenska",
    "ourLadyOfTheGateOfDawn": "Panny Márie Ostrobramskej",
    "ourLadyOfThePillar": "Panny Márie del Pilar",
    "ourLadyOfTheRosary": "Ružencovej Panny Márie",
    "ourLadyOfTheValley": "Our Lady of The Valley",
    "ourLadyOfVladimir": "Vladimírskej Bohorodičky",
    "ourLadyOfWalsingham": "Walsinghamskej Panny Márie",
    "ourLadyQueenOfPeace": "Panny Márie Kráľovnej pokoja",
    "ourLadyQueenOfPoland": "Panny Márie, Kráľovnej Poľska",
    "ourLordJesusChristTheEternalHighPriest": "Nášho Pána Ježiša Krista, najvyššieho a večného kňaza",
    "ourLordOfMiracles": "Panny Márie zázrakov",
    "popeSaintJohnPaulII": "Svätého Jána Pavla II., pápeža",
    "popeSaintJohnXXIII": "Svätého Jána XXIII., pápeža",
    "presentationOfTheBlessedVirginMary": "Obetovanie Panny Márie",
    "queenshipOfBlessedVirginMary": "Panny Márie Kráľovnej",
    "saintAdalbertBishopAndMartyr": "Svätého Vojtecha, biskupa a mučeníka",
    "saintAdalbertBishopAndMartyrSaintFidelisOfSigmaringenPriestAndMartyr": "Svätého Vojtecha, biskupa a mučeníka/Svätého Fidéla zo Sigmaringenu, kňaza a mučeníka",
    "saintAelredOfRievaulx": "Svätého Aelreda z Rievaulx",
    "saintAengusOengusBishopAndAbbot": "Svätého Aengusa (Óengusa), biskupa a opáta",
    "saintAgathaVirginAndMartyr": "Svätej Agáty, panny a mučenice",
    "saintAgnesOfBohemiaVirgin": "Svätej Anežky Českej, panny",
    "saintAgnesVirginAndMartyr": "Svätej Agnesy, panny a mučenice",
    "saintAidanBishop": "Svätého Aidana, biskupa",
    "saintAidanBishopAndTheSaintsOfLindisfarne": "Svätého Aidana, biskupa, a lindisfarnských svätých",
    "saintAidanOfLindisfarneBishopAndMissionary": "Svätého Aidana Lindisfarnského, biskupa a misionára",
    "saintAilbeBishop": "Svätého Ailba, biskupa",
    "saintAlbanMartyr": "Svätého Albána, mučeníka",
    "saintAlbertChmielowskiReligious": "Svätého Alberta Chmielowského, rehoľníka",
    "saintAlbertoHurtadoPriest": "Svätého Alberta Hurtada, kňaza",
    "saintAlbertTheGreatBishopAndDoctor": "Svätého Alberta Veľkého, biskupa a učiteľa Cirkvi",
    "saintAloysiusGonzagaReligious": "Svätého Alojza Gonzágu, rehoľníka",
    "saintAlphonsaOfTheImmaculateConceptionVirgin": "Svätej Alfonzy od Nepoškvrneného počatia, panny",
    "saintAlphonsusMariaDeLiguoriBishopAndDoctorOfTheChurch": "Svätého Alfonza Máriu de’ Liguori, biskupa a učiteľa Cirkvi",
    "saintAmandMissionary": "Svätého Milana, biskupa",
    "saintAmbroseBishopAndDoctor": "Svätého Ambróza, biskupa a učiteľa Cirkvi",
    "saintAndreBessetteReligious": "Svätého Andreja Alfréda Bessetta, rehoľníka",
    "saintAndrewApostle": "Saint Andrew, Apostle",
    "saintAndrewBobolaPriestAndMartyr": "Svätého Andreja Bobolu, kňaza a mučeníka",
    "saintAndrewDungLacAndCompanionsMartyrs": "Svätého Ondreja Dung-Laka, kňaza, a spoločníkov, mučeníkov",
    "saintAndrewKimTaegonPriestAndPaulChongHasangAndCompanionsMartyrs": "Svätých Ondreja Kima Taegona, kňaza, Pavla Chonga Hasanga a spoločníkov, mučeníkov",
    "saintAndrewTheApostle": "Svätého Ondreja, apoštola",
    "saintAndrewTheApostlePatronOfRussia": "Svätého Ondreja, apoštola, patrón Ruska",
    "saintAngelaMericiVirgin": "Svätej Angely Merici, panny",
    "saintAnnePatronOfQuebecAndSaintJoachimParentsOfTheBlessedVirginMary": "Svätých Anny, patrónky Quebecu, a Joachima, rodičov Panny Márie",
    "saintAnnoIiBishop": "Svätého Anna II., biskupa",
    "saintAnselmOfCanterburyBishopAndDoctorOfTheChurch": "Svätého Anzelma, biskupa a učiteľa Cirkvi",
    "saintAnthonyMaryClaretBishop": "Svätého Antona Máriu Clareta, biskupa",
    "saintAnthonyOfEgyptAbbot": "Svätého Antona, opáta",
    "saintAnthonyOfLisbonPriestAndDoctorOfTheChurch": "Svätého Antona Paduánskeho, kňaza a učiteľa Cirkvi",
    "saintAnthonyOfPaduaPriestAndDoctor": "Svätého Antona Paduánskeho, kňaza a učiteľa Cirkvi",
    "saintAnthonyOfSaintAnneGalvaoFreiGalvaoPriest": "Svätého Antona de Sant’Ana Galvão (brata Galvão), kňaza",
    "saintAnthonyOfTheCavesMonk": "Svätého Antona Pečerského, mnícha",
    "saintAnthonyZaccariaPriest": "Svätého Antona Márie Zaccariu, kňaza",
    "saintApollinaris": "Svätého Apolinára, biskupa a mučeníka",
    "saintAsaphBishop": "Svätého Asafa, biskupa",
    "saintAsicusBishop": "Svatého Azika, biskupa",
    "saintAthanasiusBishopAndDoctor": "Svätého Atanáza, biskupa a učiteľa Cirkvi",
    "saintAugustineOfCanterburyBishop": "Svätého Augustína z Canterbury, biskupa",
    "saintAugustineOfHippoBishopAndDoctorOfTheChurch": "Svätého Augustína, biskupa a učiteľa Cirkvi",
    "saintBarbaraVirginAndMartyr": "Svätej Barbory, panny a mučenice",
    "saintBarbaraVirginAndMartyrOrBlessedAdolphKolpingPriest": "Svätej Barbory, panny a mučenice, alebo blahoslaveného Adolfa Kolpinga, kňaza",
    "saintBarnabasTheApostle": "Svätého Barnabáša, apoštola",
    "saintBartholomewTheApostle": "Svätého Bartolomeja, apoštola",
    "saintBeatriceOfSilvaVirgin": "Svätej Beatrix da Silva, panny",
    "saintBedeTheVenerablePriestAndDoctor": "Svätého Bédu Ctihodného, kňaza a učiteľa Cirkvi",
    "saintBedeTheVenerablePriestAndDoctorSaintGregoryViiPopeSaintMaryMagdaleneDePazziVirgin": "Svätého Bédu Ctihodného, kňaza a učiteľa Cirkvi/Svätého Gregora VII., pápeža/Svätej Márie Magdalény de’ Pazzi, panny",
    "saintBenedictOfNursiaAbbot": "Svätého Benedikta, opáta, spolupatróna Európy",
    "saintBennoOfMeissenBishop": "Svätého Benna z Meißenu, biskupa",
    "saintBernadetteSoubirousVirgin": "Svätej Bernadety Soubirousovej, panny",
    "saintBernardineOfSienaPriest": "Svätého Bernardína Sienského, kňaza",
    "saintBernardOfClairvauxAbbotAndDoctorOfTheChurch": "Svätého Bernarda, opáta a učiteľa Cirkvi",
    "saintBeunoAbbot": "Svätého Beuna (Bona), opát",
    "saintBlaseBishopAndMartyrSaintAnsgarBishop": "Svätého Blažeja, biskupa a mučeníka, a svätého Oskára, biskupa",
    "saintBonaventureBishopAndDoctor": "Svätého Bonaventúru, biskupa a učiteľa Cirkvi",
    "saintBonifaceBishopAndMartyr": "Svätého Bonifáca, biskupa a mučeníka",
    "saintBrendanAbbot": "Svätého Brendana, opáta",
    "saintBridgetOfSwedenReligious": "Svätej Brigity, rehoľnice, patrónky Európy",
    "saintBrigidVirgin": "Svätej Brigity Írskej, panny",
    "saintBrotherMutienMarieReligious": "Svätého brata Mutien-Marie, rehoľníka",
    "saintBrunoBonifaceOfQuerfurtBishopAndMartyr": "Svätého Bruna Bonifáca z Querfurtu, biskupa a mučeníka",
    "saintBrunoPriest": " Svätého Bruna, kňaza",
    "saintCaesariusOfArlesBishop": "Svätého Cézara z Arles, biskupa",
    "saintCallistusIPopeAndMartyr": "Svätého Kalixta I., pápeža a mučeníka",
    "saintCamillusDeLellisPriest": "Svätého Kamila de Lellis, kňaza",
    "saintCamillusDeLellisPriestOrSaintHenryBishopAndMartyr": "Svätého Kamila de Lellis, kňaza, alebo svätého Henricha",
    "saintCaniceAbbot": "Svätého Canica, opáta",
    "saintCanuteMartyr": "Svätého Kanuta, mučeníka",
    "saintCarthageBishopMochuta": "Svätého Kartága (Mo Chutu), biskupa",
    "saintCasimir": "Svätého Kazimíra",
    "saintCatherineOfAlexandriaVirginAndMartyr": "Svätej Kataríny Alexandrijskej, panny a mučenice",
    "saintCatherineOfSienaVirginAndDoctorOfTheChurch": "Svätej Kataríny Sienskej, panny a učiteľky Cirkvi, patrónky Európy",
    "saintCeallachCelsusBishop": "Svätého Ceallacha (Celza), biskupa",
    "saintCeciliaVirginAndMartyr": "Svätej Cecílie, panny a mučenice",
    "saintCharbelMakhloufPriestAndHermit": "Svätého Sarbela Makhlūfa, kňaza",
    "saintCharlesBorromeoBishop": "Svätého Karola Boromejského, biskupa",
    "saintChristopherMagallanesAndCompanionsMartyrs": "Svätého Krištofa Magallanesa, kňaza, a spoločníkov, mučeníkov",
    "saintChristopherMartyr": "Svätého Ḱrištofa, mučeníka",
    "saintCiaranAbbot": "Svätého Kiarána, opáta",
    "saintClareVirgin": "Svätej Kláry, panny",
    "saintClementIPopeAndMartyrSaintColumbanReligious": "Svätého Klementa I., pápeža a mučeníka/Svätého Kolumbána, opáta",
    "saintClementMaryHofbauerPriest": "Svätého Klementa Márie Hofbauera, kňaza",
    "saintClementOfOhridAndGorazdBishopsAndCompanions": "Svätého Klimenta Ochridského a Gorazda, biskupov, a spoločníkov",
    "saintClotilde": "Svätej Klotildy",
    "saintColmanOfCloyneBishop": "Svätého Kolomana z Cloyne, biskupa",
    "saintColmanOfDromoreBishop": "Svätého Kolomana z Dromore, biskupa",
    "saintColmanOfKilmacduaghBishop": "Svätého Kolomana z Kilmacduagh, biskupa",
    "saintColumba": "Svätého Kolumbu, opáta",
    "saintColumbaAbbotAndMissionary": "Svätého Kolumbu, opáta a misionára",
    "saintColumbanAbbotAndMissionary": "Svätého Kolumbana, opáta a misionára",
    "saintComgallAbbot": "Svätého Comgalla, opáta",
    "saintConlethBishop": "Svätého Konleta, biskupa",
    "saintConradOfParzhamReligious": "Svätého Konráda z Parzhamu, rehoľníka",
    "saintCorbinianBishop": "Svätého Korbiniána, biskupa",
    "saintCuthbertBishop": "Svätého Cuthbert, biskupa",
    "saintCyrilOfAlexandriaBishopAndDoctor": "Svätého Cyrila Alexandrijského, biskupa a učiteľa Cirkvi",
    "saintCyrilOfJerusalemBishopAndDoctor": "Svätého Cyrila Jeruzalemského, biskupa a učiteľa Cirkvi",
    "saintDamasusIPope": "Svätého Damaza I., pápeža",
    "saintDamienDeVeusterPriest": "Svätého Damiána De Veuster, kňaza a mučeníka",
    "saintDavidBishop": "Svätého Dávida z Menevie, biskupa",
    "saintDavidLewisPriestAndMartyr": "Svätého Dávida Lewisa, kňaza a mučeníka",
    "saintDavnetVirgin": "Svätej Davnety, panny",
    "saintDeclanBishop": "Svätého Deklana, biskupa",
    "saintDeiniolBishop": "Svätého Deiniola (Daniela), biskupa",
    "saintDemetrius": "Svätého Demetra Solúnskeho, mučeníka",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriest": "Svätého Dionýza, biskupa, a spoločníkov, mučeníkov/Svätého Jána Leonardiho, kňaza",
    "saintDenisAndCompanionsMartyrsSaintJohnLeonardiPriestBlessedJohnNewmanBishop": "Svätého Dionýza, biskupa, a spoločníkov, mučeníkov/Svätého Jána Leonardiho, kňaza/Blahoslaveného Johna Henryho Newmana, kňaza",
    "saintDionysiusTheAreopagite": "Svätého Dionýza Areopagitu, biskupa a mučeníka",
    "saintDominicPriest": "Svätého Dominika, kňaza",
    "saintDominicPriest/SaintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "Svätého Dominika, kňaza/Svätých Sixta II., pápeža, a jeho spoločníkov, mučeníkov/Svätého Kajetána, kňaza",
    "saintDubriciusBishop": "Svätého Dubrícia, biskupa",
    "saintEdmundCampionPriestAndMartyr": "Svätého Edmunda Kampiána, kňaza a mučeníka",
    "saintEdmundOfAbingdonBishopOrSaintMargaretOfScotland": "Svätého Edmundá z Abingdonu, biskupa, alebo svätej Margity Škótskej",
    "saintEdwardTheConfessor": "Svätého Eduarda Vyznávača",
    "saintElijahProphet": "Svätého Eliáša, proroka",
    "saintElizabethAnnSetonReligious": "Svätej Alžbety Anny Setonovej, rehoľnice",
    "saintElizabethOfHungary": "Svätej Alžbety Uhorskej, rehoľnice",
    "saintElizabethOfHungarySaintHildaAbbessSaintHughOfLincolnBishop": "Saint Elizabeth of Hungary, Religious/Saint Hilda, Abbess/Saint Hugh of Lincoln, Bishop",
    "saintElizabethOfPortugal": "Svätej Alžbety Portugalskej",
    "saintEmeric": "Svätého Imricha",
    "saintEndaAbbot": "Svätého Endu, opáta",
    "saintEphraemDeaconDoctorOrSaintColumbaColumCilleAbbot": "Svätého Efréma, diakona a učiteľa Cirkvi, alebo svätého Kolumbu, opáta",
    "saintEphremDeaconAndDoctor": "Svätého Efréma, diakona a učiteľa Cirkvi",
    "saintEricIxMartyr": "Saint Eric IX., Martyr",
    "saintEtheldredaAudreyVirgin": "Svätej Eteldredy, panny",
    "saintEugeneDeMazenodBishop": "Svätého Eugena de Mazenod, biskupa",
    "saintEugeneEoghanBishop": "Svätého Eugena (Eoghana), biskupa",
    "saintEulaliaOfMeridaVirginAndMartyr": "Svätej Eulálie z Meridy, panny a mučenice",
    "saintEulogiusOfCordobaBishop": "Svätého Eulógia z Córdoby, biskupa",
    "saintEusebiusOfVercelliBishopSaintPeterJulianEymardPriest": "Svätého Euzébia Vercellského, biskupa/Svätého Petra Juliána Eymarda, kňaza",
    "saintEysteinnBishop": "Svätého Eysteina Erlendssona, biskupa",
    "saintEzekielMorenoBishop": "Svätého Ezechiela Morena, biskupa",
    "saintEzequielMorenoBishop": "Svätého Ezechiela Morena, biskupa",
    "saintFachananOfKilfenoraBishop": "Svätého Fachanana z Kilfenora, biskupa",
    "saintFachtnaBishop": "Svatého Fachtnu, biskupa",
    "saintFaustinaKowalskaVirginAndReligious": "Svätej Faustíny Kowalskej, panny",
    "saintFelipeDeJesusPriestAndMartyr": "Svätého Filipa od Ježiša, kňaza a mučeníka",
    "saintFerdinand": "Svätého Ferdinanda",
    "saintFergalBishopAndMissionary": "Svätého Fergala (Virgila), biskupa a misionára",
    "saintFiacreMonk": "Svätého Fiakra, mnícha",
    "saintFidelisOfSigmaringenPriestAndMartyr": "Svätého Fidéla zo Sigmaringenu, kňaza a mučeníka",
    "saintFinbarrBishop": "Svätého Finbarra, biskupa",
    "saintFinnianOfClonardBishop": "Svätého Finniana z Clonardu, biskupa",
    "saintFintan": "Svätého Fintana",
    "saintFlannanBishop": "Svätého Flannana, biskupa",
    "saintFlorianAndHisCompanionsMartyrs": "Svätých Floriána a jeho spoločníkov, mučeníkov",
    "saintFlorianMartyr": "Svätého Floriána, mučeníka",
    "saintFrancesOfRomeReligious": "Svätej Františky Rímskej, rehoľnice",
    "saintFrancesXavierCabriniVirgin": "Svätej Františky Xaviery Cabriniovej, panny",
    "saintFrancisBorgiaPriest": "Svätého Františka Borgiu, kňaza",
    "saintFrancisDeSalesBishopAndDoctor": "Svätého Františka Saleského, biskupa a učiteľa Cirkvi",
    "saintFrancisOfAssisi": "Svätého Františka Assiského",
    "saintFrancisOfPaolaHermit": "Svätého Františka z Paoly, pustovníka",
    "saintFrancisSolanusPriest": "Svätého Františka Solana, kňaza",
    "saintFrancisXavierPriest": "Svätého Františka Xaverského, kňaza",
    "saintFrancoisDeLavalBishop": "Svätého Františka de Montmorency-Laval, biskupa",
    "saintFridolinOfSackingenMonk": "Svätého Fridolína, opáta",
    "saintFructuosusSaintMartinOfDumeAndSaintGeraldBishops": "Svätých Fruktuóza z Bragy, Martin z Dumia a Geralda z Bragy, biskupov",
    "saintFursaAbbotAndMissionary": "Svätého Fursu, opát a misionár",
    "saintGallAbbotAndMissionary": "Svätého Gála, kňaza",
    "saintGenevieveVirgin": "Svätej Genovévy, panny",
    "saintGeorgeMartyr": "Svätého Juraja, mučeníka",
    "saintGeorgeMartyrSaintAdalbertBishopAndMartyr": "Svätého Juraja, mučeníka/Svätého Vojtecha, biskupa a mučeníka",
    "saintGeorgePrecaPriest": "Svätého Juraja Precu, kňaza",
    "saintGerardBishop": "Svätého Gerarda, biskupa",
    "saintGermanusOfAuxerreBishop": "Svätého Germána z Auxerre, biskupa",
    "saintGertrudeOfNivellesAbbess": "Svätej Gertrúdy z Nivelles, opátky",
    "saintGertrudeOfNivellesVirgin": "Svätej Gertrúdy z Nivelles, panny",
    "saintGertrudeTheGreatVirgin": "Svätej Gertrúdy, panny",
    "saintGobnaitVirgin": "Svätej Gobnaity, panny",
    "saintGonsaloGarciaMartyr": "Svätého Gonsala Garciu, mučeníka",
    "saintGorazdAndCompanions": "Svätého Gorazda a spoločníkov",
    "saintGotthardBishop": "Svätého Gottharda, biskupa",
    "saintGregoryTheGreatPopeAndDoctor": "Svätého Gregora Veľkého, pápeža a učiteľa Cirkvi",
    "saintHectorValdivielsoSaezMartyr": "Svätého Héctora Valdivielsa Sáeza (Benedikta od Ježiša), mučeníka",
    "saintHedwigOfPoland": "Svätej Hedvigy Poľskej",
    "saintHedwigOfSilesia": "Svätej Hedvigy, rehoľnice",
    "saintHedwigReligiousOrSaintMargaretMaryAlacoqueVirgin": "Svätej Hedvigy, rehoľnice, alebo svätej Margity Márie Alacoque, panny",
    "saintHedwigReligiousSaintMargaretMaryAlacoqueVirgin": "Svätej Hedvigy, rehoľnice/Svätej Margity Márie Alacoque, panny",
    "saintHelena": "Svätej Heleny",
    "saintHemmaOfGurk": "Svätej Emy z Gurku",
    "saintHenryBishopAndMartyr": "Svätého Henricha",
    "saintHermannJosephPriest": "Svätého Hermana Jozefa, kňaza",
    "saintHermenegildMartyr": "Svätého Hermenegilda, mučeníka",
    "saintHilaryOfPoitiersBishopAndDoctor": "Svätého Hilára, biskupa, učiteľa Cirkvi",
    "saintHildegardOfBingenAbbessAndDoctor": "Svätej Hildegardy z Bingenu, opátky a mučenice",
    "saintHubertBishop": "Svätého Huberta, biskupa",
    "saintHubertOfLiegeBishopOrSaintPirminAbbotAndBishop": "Svätého Huberta of Liége, biskupa, alebo svätého Primina, opáta a biskupa",
    "saintHyacinthPriest": "Svätého Hyacinta Poľského, kňaza",
    "saintIgnatiusOfAntiochBishopAndMartyr": "Svätého Ignáca Antiochijského, biskupa a mučeníka",
    "saintIgnatiusOfLoyolaPriest": "Svätého Ignáca z Loyoly, kňaza",
    "saintIldephonsusOfToledoBishop": "Svätého Ildefonza z Toleda, biskupa",
    "saintIlltudAbbot": "Svätého Illtuda, opáta",
    "saintIrenaeusBishopAndMartyr": "Svätého Ireneja, biskupa a mučeníka",
    "saintIrene": "Svätej Ireny",
    "saintIsidoreOfSevilleBishopAndDoctorOfTheChurch": "Svätého Izidora, biskupa a učiteľa Cirkvi",
    "saintIsidoreTheFarmer": "Svätého Izidora z Madridu, roľníka",
    "saintItaVirgin": "Svätej Ity, panny",
    "saintIvoPriest": "Svätého Ivo, kňaza",
    "saintJamesApostle": "Svätého Jakuba, apoštola",
    "saintJamesApostlePatronOfSpain": "Svätého Jakuba, apoštola, patrón Španielska",
    "saintJaneFrancesDeChantalReligious": "Svätej Jany Františky de Chantal, rehoľnice",
    "saintJanuariusBishopAndMartyr": "Svätého Januára, biskupa a mučeníka",
    "saintJarlathBishop": "Svätého Jarláta, biskupa",
    "saintJeanVianneyTheCureOfArsPriest": "Svätého Jána Márie Vianneya, kňaza",
    "saintJeromeEmilianiSaintJosephineBakhitaVirgin": "Svätého Hieronyma Emilianiho/Svätej Jozefíny Bakhity, panny",
    "saintJeromePriestAndDoctor": "Svätého Hieronyma, kňaza a učiteľa Cirkvi",
    "saintJoanOfArcVirginSecondaryPatronessOfFrance": "Svätej Jany z Arku, panny, sekundárnej patrónky Francúzska",
    "saintJoaquinaVedruna": "Svätej Joaquiny od svätého Františka z Assisi, rehoľnice",
    "saintJohnBaptistDeLaSallePriest": "Svätého Jána Krstiteľa de la Salle, kňaza",
    "saintJohnBerchmansReligious": "Svätého Jána Berchmansa, rehoľníka",
    "saintJohnBoscoPriest": "Svätého Jána Boska, kňaza",
    "saintJohnCassianPriest": "Svätého Ján Kassiána, kňaza",
    "saintJohnChrysostomBishopAndDoctor": "Svätého Jána Zlatoústeho, biskupa a učiteľa Cirkvi",
    "saintJohnDamascenePriestAndDoctor": "Svätého Jána Damascénskeho, kňaza a učiteľa Cirkvi",
    "saintJohnDamascenePriestAndDoctorOrSaintBarbaraVirginAndMartyr": "Svätého Jána Damascénskeho, kňaza a učiteľa Cirkvi, alebo svätej Barbory, panny a mučenice",
    "saintJohnDeBritoPriestAndMartyr": "Svätého Jána de Brito, kňaza a mučeníka",
    "saintJohnEudesPriest": "Svätého Jána Eudes, kňaza",
    "saintJohnIPopeAndMartyr": "Svätého Jána I., pápeža a mučeníka",
    "saintJohnJonesPriestAndMartyr": "Svätého Jána Jonesa, kňaza a mučeníka",
    "saintJohnMaciasReligious": "Svätého Jána Macíasa, rehoľníka",
    "saintJohnNepomucenePriestAndMartyr": "Svätého Jána Nepomuckého, kňaza a mučeníka",
    "saintJohnNeumannBishop": "Svätého Jána Nepomuckého Neumanna, biskupa",
    "saintJohnOfAvilaPriest": "Svätého Jána z Ávily, kňaza",
    "saintJohnOfCapistranoPriest": "Svätého Jána Kapistránskeho, kňaza",
    "saintJohnOfDuklaPriest": "Svätého Jána z Dukly, kňaza",
    "saintJohnOfGodPriest": "Svätého Jána z Boha, rehoľníka",
    "saintJohnOfGodReligious": "Svätého Jána z Boha, rehoľníka",
    "saintJohnOfKantyPriest": "Svätého Jána Kentského, kňaza",
    "saintJohnOfTheCrossDoctorOfTheChurch": "Svätého Jána z Kríža, kňaza a učiteľa Cirkvi",
    "saintJohnOfTheCrossPriestAndDoctor": "Svätého Jána z Kríža, kňaza a učiteľa Cirkvi",
    "saintJohnOgilvie": "Svätého Jána Ogilvie",
    "saintJohnRobertsPriestAndMartyr": "Svätého Jána Robertsa, kňaza a mučeníka",
    "saintJohnSarkanderPriestAndMartyrSaintZdzislawa": "Svätého Jána Sarkandera, kňaza a mučeníka/Svätej Zdislavy",
    "saintJohnTheApostleAndEvangelist": "Svätého Jána, apoštola a evanjelistu",
    "saintJosaphatBishopAndMartyr": "Svätého Jozafáta, biskupa a mučeníka",
    "saintJoseDeAnchietaPriest": "Svätého Jozefa de Anchietu, kňaza",
    "saintJosefBilczewskiBishop": "Svätého Jozefa Bilczewského, biskupa",
    "saintJoseMariaDeYermoPriest": "Svätého Jozefa Márie de Yerma, kňaza",
    "saintJosemariaEscrivaDeBalaguerPriest": "Svätého Josemaríe Escrivá de Balaguer, kňaza",
    "saintJosephSpouseOfTheBlessedVirginMaryPrincipalPatronOfCanada": "Svätého Jozefa, ženícha Panny Márie, hlavný patrón Kanady",
    "saintJosephTheWorker": "Svätého Jozefa, robotníka",
    "saintJozefBilczewskiBishop": "Svätého Jozefa Bilczewski, biskupa",
    "saintJozefSebastianPelczar": "Svätého Jozefa Sebastiána Pelczara, biskupa",
    "saintJuanDiego": "Svätého Jána Didaka (Juana Diega) Cuauhtlatoatzina",
    "saintJuanDiegoCuauhtlatoatzin": "Svätého Jána Didaka Cuauhtlatoatzina",
    "saintJulianaOfLiegeVirgin": "Svätej Juliány z Liége, panny",
    "saintJulieBilliartVirgin": "Svätej Júlie Billiart, panny",
    "saintJustinMartyr": "Svätého Justína, mučeníka",
    "saintKateriTekakwithaVirgin": "Svätej Kataríny Tekakwithy, panny",
    "saintKatharineDrexelVirgin": "Svätej Kataríny Drexelovej, panny",
    "saintKentigern": "Svätého Munga",
    "saintKevinAbbot": "Svätého Kevina, opáta",
    "saintKieranBishop": "Svätého Ciarána, biskup",
    "saintKilianBishopAndCompanionsMartyrs": "Svätého Kiliána, biskupa, a spoločníkov, mučeníkov",
    "saintKillianBishopAndMartyr": "Svätého Killiana, biskupa a mučeníka",
    "saintKingaVirgin": "Svätej Kingy, panny",
    "saintLadislaus": "Svätého Ladislava",
    "saintLambertBishopAndMartyr": "Svätého Lamberta z Maastrichtu, biskupa a mučeníka",
    "saintLaurenceOTooleBishop": "Svätého Vavrinec O’Toole, biskupa",
    "saintLawrenceOfBrindisiPriestAndDoctor": "Svätého Vavrinca z Brindisi, kňaza a učiteľa Cirkvi",
    "saintLawrenceOfRomeDeaconAndMartyr": "Svätého Vavrinca, diakona a mučeníka",
    "saintLeanderBishop": "Svätého Leandra zo Sevilly, biskupa",
    "saintLeobaAbbess": "Svätej Leoby, opátky",
    "saintLeoIxPopeOrBlessedMarcelCalloMartyr": "Svätého Lea IX., pápeža, alebo blahoslaveného Marcela Calla, mučeníka Leo IX, Pope Or Blessed Marcel Callo, Martyr",
    "saintLeonardOfNoblacHermit": "Svätého Leonarda z Noblatu, pustovníka",
    "saintLeopoldIII": "Svätého Leopolda III., pápeža",
    "saintLeopoldMandicPriest": "Svätého Leopolda Bogdana Mandića, kňaza a rehoľníka",
    "saintLeoTheGreatPopeAndDoctor": "Svätého Leva Veľkého, pápeža a učiteľa Cirkvi",
    "saintLorenzoRuizAndCompanionsMartyrs": "Svätého Vavrinca Ruiza a spoločníkov, mučeníkov",
    "saintLouisBertrandPriest": "Svätého Ľudovíta Bertranda, kňaza a rehoľníka",
    "saintLouisGrignonDeMontfortPriest": "Svätého Ľudovíta Márie Grignona de Montfort, kňaza",
    "saintLouisSaintJosephOfCalasanzPriest": "Svätého Ľudovíta/Svätého Jozefa Kalazanského, kňaza",
    "saintLuciusOfChurBishopAndMartyr": "Svätého Lucia z Chur, biskupa a mučeníka",
    "saintLucyOfSyracuseVirginAndMartyr": "Svätej Lucie, panny a mučenice",
    "saintLudgerBishop": "Svätého Ludgera z Münsteru, biskupa",
    "saintLudmilaMartyr": "Svätej Ľudmily, mučenice",
    "saintLuigiOrionePriest": "Svätého Alojza Orione, kňaza",
    "saintLukeTheEvangelist": "Svätého Lukáša, evanjelistu",
    "saintLydiaOfPhilippi": "Svätej Lýdie z Filíp",
    "saintMacartanBishop": "Svätého Makartána, biskupa",
    "saintMacNissiBishop": "Svätého Mac Nissiho, biskupa",
    "saintMaelruainMaolruainVirgin": "Svätej Máel Ruainy (Maolruainy), biskupa a opáta",
    "saintMagnusMartyr": "Svätého Magnusa Erlendssona, mučeníka",
    "saintMalachyBishop": "Svätého Malachiáša, biskupa",
    "saintMarcellinChampagnatPriest": "Svätého Marcelína Champagnata, kňaza",
    "saintMargaretMaryAlacoque": "Svätej Margity Márie Alacoque, panny",
    "saintMargaretOfAntiochVirginAndMartyr": "Svätej Margity Antiochijskej, panny a mučenice",
    "saintMargaretOfHungary": "Svätej Margity Uhorskej, rehoľnice",
    "saintMargaretOfScotland": "Svätej Margity Škótskej",
    "saintMargaretOfScotlandSaintGertrudeTheGreatVirgin": "Svätej Margity Škótskej/Svätej Gertrúdy, panny",
    "saintMargueriteBourgeoysVirgin": "Svätej Margaréty Bourgeoys, panny",
    "saintMargueriteDYouvilleReligious": "Svätej Margaréty d’Youville, rehoľnice",
    "saintMariaDeJesusSacramentadoVenegasVirgin": "Svätej Márie od Ježiša v Najsvätejšej Sviatosti, Panny",
    "saintMariaGorettiVirginAndMartyr": "Svätej Márie Goretti, panny a mučenice",
    "saintMariaMicaelaOfTheBlessedSacramentVirgin": "Svätej Márie Michaely od Najsvätejšej Sviatosti, rehoľnice",
    "saintMarianaDeJesusDeParedesVirgin": "Svätej Márie Anny od Ježiša (de Paredes), panny",
    "saintMarieOfTheIncarnationReligious": "Svätej Márie od Vtelenia, rehoľnice",
    "saintMarina": "Svätej Maríny",
    "saintMarkApostle": "Svätého Marka, apoštola",
    "saintMarkoKrizinPriestAndMartyr": "Svätého Marka Križina, kňaza a mučeníka",
    "saintMarkTheEvangelist": "Svätého Marka, evanjelistu",
    "saintMaroun": "Svätého Maróna, pustovníka",
    "saintMartha": "Svätej Marty",
    "saintMartinDePorresReligious": "Svätého Martina de Porres, rehoľníka",
    "saintMartinIPopeAndMartyr": "Svätého Martina I., pápeža a mučeníka",
    "saintMartinOfToursBishop": "Svätého Martina z Tours, biskupa",
    "saintMaryMacKillopVirgin": "Svätej Márie MacKillopovej, Panny",
    "saintMaryMagdalene": "Svätej Márie Magdalény",
    "saintMaryOfTheCrossVirgin": "Svätej Márie od Kríža, panny",
    "saintMatilda": "Svätej Matildy",
    "saintMatthewApostleAndEvangelist": "Svätého Matúša, apoštola a evanjelistu",
    "saintMatthiasTheApostle": "Svätého Mateja, apoštola",
    "saintMauriceAndCompanionsMartyrs": "Svätého Maurícia a spoločníkov, mučeníkov",
    "saintMaurusBishop": "Svätého Maura, biskupa",
    "saintMaximilianMaryKolbePriestAndMartyr": "Svätého Maximiliána Máriu Kolbeho, kňaza a mučeníka",
    "saintMeinradMartyr": "Svätého Meinrada, mučeníka",
    "saintMelBishop": "Svätého Mela, biskupa",
    "saintMelchiorGrodzieckiPriestAndMartyr": "Svätého Melichara Grodzieckého, kňaza a mučeníka",
    "saintMiguelFebresCorderoReligious": "Svätého Michala Febresa Cordera, rehoľníka",
    "saintMolaiseLaisrenLaserianBishop": "Svätého Molaise (Laisrena, Laseriana), biskupa",
    "saintMonica": "Svätej Moniky",
    "saintMoninneVirgin": "Svätej Moninny, panny",
    "saintMuiredachBishopSaintAttractaVirginOrSaintLeliaVirgin": "Svätého Muredacha, biskupa, alebo svätej Atrakty, panny, alebo svätej Lelie, panny",
    "saintMunchinBishop": "Svätého Munchina, biskupa",
    "saintNicholasBishop": "Svätého Mikuláša, biskupa",
    "saintNicholasOfFlueHermit": "Svätého Mikuláša z Flüe, pustovníka",
    "saintNikolaTavelicPriestAndMartyr": "Svätého Nikolu Tavelića, kňaza a mučeníka",
    "saintNinian": "Svätého Niniána ",
    "saintNorbertBishop": "Svätého Norberta, biskupa",
    "saintNunoDeSantaMaria": "Svätého Nuna od Svätej Panny",
    "saintOdileOfAlsaceAbbess": "Svätej Otílie, opátky",
    "saintOlafIiMartyr": "Svätého Olafa II., mučeníka",
    "saintOlga": "Svätej Oľgy",
    "saintOliverPlunketBishopAndMartyr": "Svätého Olivera Plunketa, biskupa a mučeníka",
    "saintOliverPlunkettBishopAndMartyr": "Svätého Olivera Plunketta, biskupa a mučeníka",
    "saintOtteranMonk": "Svätého Otterána, mnícha",
    "saintOttoOfBambergBishop": "Svätého Ota z Bambergu, biskupa",
    "saintPantaleon": "Svätého Pantaleóna",
    "saintPaschalBaylon": "Svätého Paschala Baylóna, rehoľníka",
    "saintPatrickBishop": "Svätého Patrika, biskupa",
    "saintPaulinaOfTheAgonizingHeartOfJesusVirgin": "Svätej Paulíny trpiaceho Srdca Ježišovho, panny",
    "saintPaulinusOfNolaBishopSaintsJohnFisherBishopAndThomasMoreMartyrs": "Svätého Pavlína z Noly, biskupa/Svätých Jána Fishera, biskupa, a Tomáša Mórusa, mučeníkov",
    "saintPaulinusOfTrierBishop": "Svätého Paulína z Trevíra, biskupa",
    "saintPaulinusOfYorkBishop": "Svätého Paulína z Yorku, biskupa",
    "saintPaulMikiAndCompanionsMartyrs": "Svätého Pavla Mikiho a spoločníkov, mučeníkov",
    "saintPaulOfTheCrossPriest": "Svätého Pavla z Kríža, kňaza",
    "saintPedroCalungsodMartyr": "Svätého Petra Calungsoda, mučeníka",
    "saintPelagiusMartyr": "Svätého Pelágia z Córdoby, mučeníka",
    "saintPeterCanisiusPriestAndDoctor": "Svätého Petra Kanízia, kňaza a učiteľa Cirkvi",
    "saintPeterChanelPriestAndMartyrSaintLouisGrignonDeMontfortPriest": "Svätého Petra Chanela, kňaza a mučeníka/Svätého Ľudovíta Márie Grignion de Montfort, kňaza",
    "saintPeterChrysologusBishopAndDoctor": "Svätého Petra Chryzológa, biskupa a učiteľa Cirkvi",
    "saintPeterClaverPriest": "Svätého Petra Clavera, kňaza",
    "saintPeterDamianBishopAndDoctorOfTheChurch": "Svätého Petra Damianiho, biskupa a učiteľa Cirkvi",
    "saintPeterOfAlcantaraPriest": "Saint Peter of Alkantary, kňaza",
    "saintPhilipNeriPriest": "Svätého Filipa Neriho, kňaza",
    "saintPioOfPietralcina": "Svätého Pia z Pietrelčiny, kňaza",
    "saintPioOfPietrelcinaPadrePioPriest": "Svätého Pia z Pietrelčiny, kňaza",
    "saintPiusVPope": "Svätého Pia V., pápeža",
    "saintPiusXPope": "Svätého Pia X., pápeža",
    "saintPolycarpBishopAndMartyr": "Svätého Polykarpa, biskupa a mučeníka",
    "saintPothinusBishopSaintBlAndinaVirginAndTheirCompanionsMartyrs": "Svätých Potína, biskupa, Blandíny, panny, a ich spoločníkov, mučeníkov",
    "saintProcopiusAbbot": "Svätého Prokopa, opáta",
    "saintPubliusBishop": "Svätého Publia, biskupa",
    "saintQuirinusOfSescia": "Svätého Kvirína zo Sisaku",
    "saintRabanusMaurusBishop": "Svätého Rabana Maura, biskupa",
    "saintRadimBishop": "Svätého Radima, biskupa",
    "saintRafaelGuizarYValenciaBishop": "Svätého Rafaela Guízara, biskupa",
    "saintRafalKalinowskiPriest": "Svätého Rafael Kalinowského, kňaza",
    "saintRafqaRebeccaVirgin": "Svätej Rafky (Rebeky), panny",
    "saintRaymondOfPenyafortPriest": " Svätého Rajmunda z Peňafortu, kňaza",
    "saintRemigiusBishop": "Svätého Remígia, biskupa",
    "saintRichardGwynMartyr": "Svätého Richarda Gwyna, mučeníka",
    "saintRichardOfChichesterBishop": " Svätého Richarda z Chichesteru, biskupa",
    "saintRitaOfCascia": "Svätej Rity z Cascie, rehoľnice",
    "saintRobertBellarmineBishopAndDoctor": "Svätého Róberta Bellarmína, biskupa a učiteľa Cirkvi",
    "saintRocco": "Svätého Rocha, pútnika",
    "saintRoch": "Svätého Rochusa",
    "saintRomualdAbbot": "Svätého Romualda, opáta",
    "saintRoseOfLima": "Svätej Ruženy Limskej, panny",
    "saintRosePhilippineDuchesneVirgin": "Svätej Ruženy Filipíny Duchesne, panny",
    "saintsAlbanJuliusAndAaronMartyrs": "Svätého Albána, Júlia and Árona, mučeníkov",
    "saintsAndrewZoerardusAndBenedictHermits": "Svätých Andreja-Svorada a Benedikta, pustovníkov",
    "saintsAndrewZorardAndBenedictHermits": "Svätých Andreja-Svorada a Benedikta, pustovníkov",
    "saintsAugustineZhaoRongPriestAndCompanionsMartyrs": "Svätých Augustína Zhao Rong, kňaza, a spoločníkov, mučeníkov",
    "saintsBasilTheGreatAndGregoryNazianzenBishopsAndDoctors": "Svätých Bazila Veľkého a Gregora Nazianzského, biskupov a učiteľov Cirkvi",
    "saintsBenedyktJanMateuszIsaakAndKrystynMartyrs": "Svätých Benedikta, Jána, Mateja, Izáka a Kristína (Piatich bratov pustovníkov), mučeníkov",
    "saintsBorisAndGlebMartyrs": "Svätých Borisa a Gleba, mučeníkov",
    "saintsCanuteEricAndOlafMartyrs": "Svätých Kanuta, Erika a Olafa, mučeníkov",
    "saintsChadAndCeddBishop": "Svätých Chada a Cedda, biskupov",
    "saintsCharlesLwangaAndCompanionsMartyrs": "Svätých Karola Lwangu a spoločníkov, mučeníkov",
    "saintScholasticaVirgin": "Svätej Školastiky, panny",
    "saintsConradAndGebhardOfConstanceBishops": "Svätých Konráda a Gebharda z Kostnice, biskupov",
    "saintsCorneliusPopeAndCyprianBishopMartyrs": "Svätých Kornélia, pápeža, a Cypriána, biskupa, mučeníkov",
    "saintsCosmasAndDamian": "Svätých Kozmu a Damiána, mučeníkov",
    "saintsCosmasAndDamianMartyrs": "Svätých Kozmu a Damiána, mučeníkov",
    "saintsCyrilMonkAndMethodiusBishop": "Svätých Cyrila a Metoda, slovanských vierozvestov",
    "saintSenanBishop": "Svätého Senana, biskupa",
    "saintSeverinusOfNoricumMonk": "Svätého Severína z Norika, kňaza",
    "saintsFabianPopeAndSebastianMartyrs": "Svätých Fabiána, pápeža, a Šebastiána, mučeníkov",
    "saintsFelipeDeJesusPaulMikiAndCompanionsMartyrs": "Svätého Filipa od Ježiša, Pavla Mikiho a spoločníkov, mučeníkov",
    "saintsFructuosusBishopAndAuguriusAndEulogiusDeaconsMartyrs": "Svätých Fruktuóza z Bragy, biskupa, a Augúria a Eulógia, diakonov, mučeníkov",
    "saintsHenryAndCunigunde": "Svätého Henricha a Kunigundy",
    "saintSigismundMartyr": "Svätého Žigmunda Burgundského, mučeníka",
    "saintSimonOfLipnicaPriest": "Svätého Šimona z Lipnice, kňaza",
    "saintSixtusIiPopeAndCompanionsMartyrsSaintCajetanPriest": "Svätých Sixta II., pápeža, a jeho spoločníkov, mučeníkov/Svätého Kajetána, kňaza",
    "saintsJeanDeBrebeufAndIsaacJoguesPriestsAndCompanionsMartyrsSaintPaulOfTheCrossPriest": "Svätých Jána de Brébeuf a Izáka Joguesa, kňazov, a ich spoločníkov, mučeníkov/Svätého Pavla z Kríža, kňaza",
    "saintsJoachimAndAnne": "Svätých Joachima a Anny, rodičov Panny Márie",
    "saintsJohnFisherBishopAndThomasMoreMartyrs": "Svätých Jána Fishera, biskupa, a Tomáša Mórusa, mučeníkov",
    "saintsLawrenceRuizAndCompanionsMartyrs": "Svätého Vavrinca Ruiza a spoločníkov, mučeníkov",
    "saintsMarcellinusAndPeterMartyrs": "Svätých Marcelína a Petra, mučeníkov",
    "saintsMargaretClitherowAnneLineAndMargaretWardMartyrs": "Svätej Margity Clitherowová, Anny Linová a Margity Wardová, mučeníc",
    "saintsMarkoKrizinMelicharGrodeckiAndStephenPongracPriestsAndMartyrs": "Svätých troch košických mučeníkov – Marka Križina, Melichara Grodzieckeho a Štefana Pongrácza, kňazov a mučeníkov",
    "saintsMichaelGabrielAndRaphaelArchangels": "Svätých Michala, Gabriela a Rafaela, archanjelov",
    "saintsNereusAndAchilleusMartyrsSaintPancrasMartyr": "Svätých Nerea a Achila, mučeníkov/Svätého Pankráca, mučeníka",
    "saintSoledadTorresAcostaVirgin": "Svätej Márie Soledad Torres y Acosty, panny",
    "saintsPedroBautistaPaulMikiAndCompanionsMartyrs": "Svätého Petra Bautistu, Pavla Mikiho a spoločníkov, mučeníkov",
    "saintsPerpetuaAndFelicityMartyrs": "Svätej Perpetuy a Felicity, mučeníc",
    "saintsPhilipAndJamesApostles": "Svätých Filipa a Jakuba, apoštolov",
    "saintsPhilipEvansAndJohnLloydPriestsAndMartyrs": "Svätých Filipa Evansa a Jána Lloyda, kňazov a mučeníkov",
    "saintsPontianPopeAndHippolytusPriestMartyrs": "Svätých Ponciána, pápeža, a Hipolyta, kňaza, mučeníkov",
    "saintSpyridon": "Svätého Spyridóna Trimifuntského, biskupa",
    "saintsRoqueGonzalezAlfonsoRodriguezOlmedoAndJuanDelCastilloPriestsAndMartyrs": "Svätého Rochusa Gonzáleza, Alfonza Rodrígueza Olmeda a Jána del Castilla, kňazov a mučeníkov",
    "saintsRupertAndVirgiliusOfSalzburgBishops": "Svätých Ruperta a Virgila zo Salzburgu, biskupov",
    "saintsSimonAndJudeApostles": "Svätých Šimona a Júdu, apoštolov",
    "saintStanislausBishopAndMartyr": "Svätého Stanislava, biskupa a mučeníka",
    "saintStanislausKazimierczykPriest": "Svätého Stanislava Kazimierczyka, kňaza",
    "saintStanislausKostkaReligious": "Svätého Stanislava Kostku, rehoľníka",
    "saintStephenOfHungary": "Svätého Štefana Uhorského",
    "saintStephenTheFirstMartyr": "Svätého Štefana, prvého mučeníka",
    "saintsTimothyAndTitusBishops": "Svätých Timoteja a Títa, biskupov",
    "saintSunnivaVirginAndMartyr": "Svätej Sunnivy, panny a mučenice",
    "saintSwithunBishop": "Svätého Swithuna, biskupa",
    "saintSylvesterIPope": "Svätého Silvestra I., pápeža",
    "saintTeiloBishop": "Svätého Teila (Teliava), biskupa",
    "saintTeresaBenedictaOfTheCrossEdithSteinVirginAndMartyr": "Svätej Terézie Benedikty z Kríža (Edity Steinovej), panny a mučenice, spolupatrónky Európy",
    "saintTeresaOfCalcuttaReligious": "Svätej Terézie z Kalkaty (Matky Terezy), panny a rehoľnice",
    "saintTeresaOfJesusJornetEIbarsVirgin": "Svätej Terezy od Ježiša Jornet e Ibars, panny",
    "saintTeresaOfJesusVirginAndDoctorOfTheChurch": "Svätej Terézie od Ježiša (z Ávily), panny a učiteľky Cirkvi",
    "saintTeresaOfLosAndesVirgin": "Svätej Terézie z Los Andes, panny",
    "saintTheodoreOfCanterburyBishop": "Svätého Teodora z Canterbury, biskupa",
    "saintTheodosiusOfTheCavesAbbot": "Svätého Teodóza Pečerského, opáta",
    "saintTheotoniusPriest": "Svätého Teotónia, kňaza",
    "saintThereseOfTheChildJesusVirginAndDoctor": "Svätej Terézie od Dieťaťa Ježiša (z Lisieux), panny a učiteľky Cirkvi",
    "saintThereseOfTheChildJesusVirginSecondaryPatronessOfFrance": "Svätej Terézie od Dieťaťa Ježiša (z Lisieux), panny a učiteľky Cirkvi, sekundárnej patrónky Francúzska",
    "saintThomasAquinasPriestAndDoctor": "Svätého Tomáša Akvinského, kňaza a učiteľa Cirkvi",
    "saintThomasBecketBishopAndMartyr": "Svätého Tomáša Becketa, biskupa a mučeníka",
    "saintThomasOfVillanovaBishop": "Svätého Tomáša z Villanovy, biskupa",
    "saintThomasRokuzayemonPriestAndCompanionsMartyrs": "Svätého Tomáša Rokuzayemona, kňaza, a spoločníkov, mučeníkov",
    "saintThomasTheApostle": "Svätého Tomáša, apoštola",
    "saintThorfinnBishop": "Svätého Torfina Hamarského, biskupa",
    "saintThorlacBishop": "Svätého Torlaka, biskupa",
    "saintTuribiusOfMogrovejoBishop": "Svätého Turibia de Mongrovejo, biskupa",
    "saintUlrichOfAugsburg": "Svätého Ulricha, biskupa",
    "saintUrsulaAndCompanionsVirginsAndMartyrs": "Svätej Uršule a spoločníčok, panien a mučeníc",
    "saintUrsulaLedochowskaVirgin": "Svätej Uršule Ledochowskej, panny",
    "saintValentineOfRaetiaBishop": "Svätého Valentína z Raetie, biskupa",
    "saintVincentDeaconAndMartyr": "Svätého Vincenta, diakona a mučeníka",
    "saintVincentDeaconAndMartyrOrSaintMarianneCopeVirgin": "Svätého Vincenta zo Saragossy, diakona a mučeníka, alebo svätej Marianny z Molokai, rehoľnice",
    "saintVincentDePaulPriest": "Svätého Vincenta de Paul, kňaza",
    "saintVincentFerrerPriest": "Svätého Vincenta Ferrera, kňaza",
    "saintVincentPallottiPriest": "Svätého Vincenta Pallottiho, kňaza",
    "saintVitusMartyr": "Svätého Víta, mučeníka",
    "saintVladimirTheGreat": "Svätého Vladimíra Veľkého",
    "saintWalburgaAbbess": "Svätej Valburgy, opátky",
    "saintWenceslausMartyr": "Svätého Václava, mučeníka",
    "saintWenceslausMartyrSaintsLawrenceRuizAndCompanionsMartyrs": "Svätého Václava, mučeníka/Svätého Vavrinca Ruiza a spoločníkov, mučeníkov",
    "saintWendelinAbbot": "Svätého Vendelína, opáta",
    "saintWilfridBishop": "Svätého Vilfrida, biskupa",
    "saintWillibaldBishop": "Svätého Willibalda, biskupa",
    "saintWillibrordBishop": "Svätého Willibrorda, biskupa",
    "saintWinefrideVirgin": "Svätej Winefridy, panny",
    "saintWolfgangBishop": "Svätého Wolfganga z Regensburgu, biskupa",
    "saintWolfgangOfRegensburgBishop": "Svätého Wolfganga z Regensburgu, biskupa",
    "saintWulstanBishop": "Svätého Vulstana, biskupa",
    "saintZdislava": "Svätej Zdislavy",
    "saintZygmuntGorazdowskiPriest": "Svätého Žigmunda Gorazdowského, kňaza",
    "saintZygmuntSzczesnyFelinskiBishop": "Svätého Zygmunta Szczęsného Felińskiho, biskupa",
    "santoNinoInfantJesus": "Svätého Dieťaťa z Cebu",
    "sevenHolyFoundersOfTheServiteOrder": "Siedmich svätých zakladateľov rehole Služobníkov Panny Márie",
    "shipwreckOfSaintPaulApostle": "Vraku lode svätého Pavla, apoštola",
    "shroveMonday": "Fašiangový pondelok",
    "shroveTuesday": "Fašiangový utorok",
    "stDunstanArchbishopOfCanterbury": "Svätého Dunstana z Canterbury, biskupa",
    "theBeheadingOfSaintJohnTheBaptistMartyr": "Mučenícka smrť svätého Jána Krstiteľa",
    "theEnglishMartyrs": "Svätých anglických mučeníkov",
    "theFiveWoundsOfTheLord": "Piatich Rán Krista Pána",
    "theMostHolyNameOfJesus": "Najsvätejšieho mena Ježiš",
    "theSixWelshMartyrsAndCompanions": "Šiestich waleských mučeníkov a spoločníkov",
    "transferOfTheRelicsOfSaintStephen": "Presunu ostatkov svätého Štefana Uhorského",
    "vietnameseMartyrs": "Vietnamských mučeníkov",
    "visitationOfTheBlessedVirginMary": "Návšteva Panny Márie",
    "waitangiDay": "Deň Waitangi"
  }
};
